import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthState } from '@store/auth/auth.state';
import { catchError } from 'rxjs/operators';
import { ClearAuthData } from '@store/auth/auth.actions';
import { PosthogService } from '@core/services';
import { ErrorTracked, PosthogEvent } from '@core/models';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    public store: Store,
    private posthogService: PosthogService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.store.selectSnapshot(AuthState.token);
    const user = this.store.selectSnapshot(AuthState.user);

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req).pipe(
      catchError(err => {
        this.posthogService.capture(
          PosthogEvent.ErrorTracked,
          new ErrorTracked().create(err, req, user)
        );

        if (err.status === 403 && token) {
          this.store.dispatch(new ClearAuthData());
          err.error = {
            code: 404,
            string: 'Session expired, we are sorry. Please refresh the page.'
          };
        }

        return throwError(err);
      })
    );
  }
}
